import { getTokens, msalInstance } from '@sib/auth';
import type { InternalAxiosRequestConfig } from 'axios';
import { CustomHeaders } from '../utils';

export const authRequestMiddleware = async ({
  disableAuth = false,
  withAccessToken = false,
  ...req
}: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
  const tokens = await getTokens({ instance: msalInstance });

  if (!disableAuth && tokens?.idToken)
    req.headers.Authorization = `Bearer ${tokens.idToken}`;
  if (withAccessToken && tokens?.accessToken)
    req.headers[CustomHeaders.MsAccessToken] = tokens.accessToken;

  return req;
};
